// extracted by mini-css-extract-plugin
export default {"container":"SearchWithSelect_container__c4dzq","icon":"SearchWithSelect_icon__dwVaP","selectBox":"SearchWithSelect_selectBox__e33e0"};